import { Alert, AlertProps } from "@mui/material";
import { neutral, yellow, InfoCircleFillIcon } from "@flat-ui";

/**
 * Renders a FARO alert.
 *
 * TODO: If a severity other than warning is used, the styling needs to be updated.
 */
export function FaroAlert(
  props: React.PropsWithChildren<AlertProps>
): JSX.Element {
  return (
    <Alert
      {...props}
      icon={props.severity === "warning" ? <InfoCircleFillIcon /> : undefined}
      sx={{
        ...props.sx,
        fontSize: "14px",
        color: neutral[1000],
        backgroundColor: props.severity === "warning" ? yellow[50] : undefined,
      }}
    >
      {props.children}
    </Alert>
  );
}
